/**
 * Enter / Shift+Enter navigation across a group of inputs that share the same
 * `name` attribute. Walks DOM order, so it naturally follows the visible row
 * order even when the outer list is virtualized or re-sorted.
 */
export function navigateNamedInputs(
  event: React.KeyboardEvent<HTMLInputElement>,
  groupName: string
) {
  if (event.key !== 'Enter') {
    return;
  }

  event.preventDefault();
  const inputs = Array.from(document.getElementsByName(groupName)) as HTMLInputElement[];
  const currentIndex = inputs.indexOf(event.currentTarget);
  if (currentIndex < 0) {
    return;
  }

  const next = inputs[currentIndex + (event.shiftKey ? -1 : 1)];
  if (next) {
    next.focus();
    next.select();
  }
}
